import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import Row from "../../../layout/Row";
import Col from "../../../layout/Col";
import SectionView from "../../../layout/section/SectionView";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import AssetSelectionComponent from "./AssetSelectionComponent";
import {none, Option, option} from "ts-option";
import CurrencyHelper from "../../../../helper/CurrencyHelper";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import AssetSearch from "../../../../model/asset/AssetSearch";
import {Dispatch} from "redux";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import {addAssetToBillOfMaterials} from "../../../../store/action/billOfMaterials/billOfMaterials";
import {connect} from "react-redux";
import {QuotePartsPriceStrategy} from "../../../../model/quote/Quote";

interface IComponentProps {
	/**
	 * On close button click.
	 */
	closeModal: () => void;
	/**
	 * Bill of materials id
	 */
	bomId: string;
	/**
	 * Job id
	 */
	jobId: string;
	/**
	 * Parts Price Strategy
	 */
	partsPriceStrategy: string
}

interface DispatchProps {
	/**
	 */
	addAssetToBillOfMaterials: (bomId: string, assetId: string, jobId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void
}

interface IState {
	/**
	 * Asset selected to add.
	 */
	selectedAsset: Option<AssetSearch>;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & DispatchProps;

class AddAssetModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {
			selectedAsset: none,
			isSubmitting: false
		};
		this.renderSelectedAsset = this.renderSelectedAsset.bind(this);
		this.addAsset = this.addAsset.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.closeModal} title={'Add an asset to order'}>
				<SectionView>
					<div style={{marginTop: '25px', height: '300px'}}>
						<Row>
							<Col>
								<FormGroup label={'Asset'}>
									{this.state.selectedAsset.map(this.renderSelectedAsset).getOrElse(() =>
										<AssetSelectionComponent
											onSelect={(asset) => this.setState({selectedAsset: option(asset)})}
											placeholder={'Search by manufacturer, model'}
											partsPriceStrategy={this.props.partsPriceStrategy}/>
									)}
								</FormGroup>
							</Col>
						</Row>
					</div>
				</SectionView>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.closeModal}
									label={"Cancel"}
									disabled={this.state.isSubmitting}/>
					<ButtonPrimary onClick={this.addAsset}
								   label={"Add"}
								   disabled={this.state.isSubmitting ||  this.state.selectedAsset.isEmpty}
								   isLoading={this.state.isSubmitting}/>
				</FormButtonsView>
			</Modal>
		);
	}

	renderSelectedAsset(asset: AssetSearch) {
		return (
			<div className="bom-selection selected">
				<div className="c-selection-bom-modal_select-option-component">
					<div className="c-selection-bom-modal_select-option-component_labels">
						<div>
							<span className="c-selection-bom-modal_select-option-component_labels_column">
								<b className="c-selection-bom-modal_select-option-component_labels_blue-color">
									{asset.manufacturer.getOrElse('')}</b>
							</span>
							<span className="c-selection-bom-modal_select-option-component_labels_move-right">{asset.model}</span>

						</div>
						<div className="c-selection-bom-modal_select-option-component_labels_blue-color fit-content">
							<span><b>{CurrencyHelper.toCurrency(asset.getPrice(this.props.partsPriceStrategy))}</b></span>
							<ButtonTertiary label={'X'} onClick={() => this.setState({selectedAsset: none})}/>
						</div>
					</div>
				</div>
			</div>
		)
	}

	addAsset() {
		if(this.state.selectedAsset.isDefined) {
			this.setState({isSubmitting: true}, () => {
				this.props.addAssetToBillOfMaterials(this.props.bomId, this.state.selectedAsset.get.id,
					this.props.jobId,
					this.props.closeModal,
					(error) => {
						this.setState({isSubmitting: false});
						notifyBugsnagAndShowToast(error, 'Add an asset to order');
					});
			});
		}
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		addAssetToBillOfMaterials: (bomId: string,
			assetId: string,
			jobId: string,
			onSuccess: OnSuccess,
			onFailure: OnFailure) => dispatch(
			addAssetToBillOfMaterials(bomId, assetId, jobId, onSuccess, onFailure)
		)
	}
}

export default connect(null, mapDispatchToProps)(AddAssetModal);
